// extracted by mini-css-extract-plugin
export default {"inputWrap":"V2ZZi8uVOYxdezFlg8Pi","scopesSelect":"jJvYQETdokrrb316TgFg"};